import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-360f1dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global space-y-4 text-gray-800" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = { class: "text-green-600" }
const _hoisted_6 = { class: "flex justify-between items-center" }
const _hoisted_7 = { class: "text-gray-400" }
const _hoisted_8 = { class: "flex space-x-2" }
const _hoisted_9 = { class: "px-4 py-2 space-x-2 border border-gray-200 rounded-3xl flex items-center" }
const _hoisted_10 = { class: "flex justify-between items-center" }
const _hoisted_11 = { class: "flex items-center space-x-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-gray-500"
}

import { ref } from "vue";
import {
  ViewListIcon,
  ExternalLinkIcon,
  PrinterIcon,
  StarIcon,
  PaperClipIcon,
  DocumentAddIcon,
} from "@heroicons/vue/outline";
import Process from "@/types/documents/process/Process";
import ProcessTable from "@/views/documents/process/ProcessTable.vue";
import { formatDateTime } from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    title: null,
    attachedFilesCount: null,
    registrationId: null,
    creationDate: null,
    startedAt: null,
    creatorName: null,
    categoryName: null,
    processes: null
  },
  setup(__props: any) {



const extended = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'ProcessUserDetails', params: { id: __props.id } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ExternalLinkIcon), { class: "w-6 h-6 text-primary-300" }),
        _createVNode(_unref(PrinterIcon), { class: "w-6 h-6 text-primary-300" }),
        _createVNode(_unref(StarIcon), { class: "w-6 h-6 text-primary-300" })
      ])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("document.regNumber")) + ": " + _toDisplayString(__props.registrationId), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("document.category")) + ": " + _toDisplayString(__props.categoryName), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(PaperClipIcon), { class: "w-6 h-6 text-green-400" }),
          _createElementVNode("span", null, _toDisplayString(__props.attachedFilesCount), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(DocumentAddIcon), { class: "w-8 h-8 text-gray-600" }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("document.createdBy")) + " " + _toDisplayString(_unref(formatDateTime)(__props.creationDate)) + " | " + _toDisplayString(__props.creatorName), 1)
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "no-underline text-primary-300 font-semibold",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (extended.value = !extended.value), ["prevent"]))
      }, [
        _createVNode(_unref(ViewListIcon), { style: {"width":"20px","display":"inline-block","margin-bottom":"1px"} }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("document.status")), 1)
      ])
    ]),
    (__props.startedAt)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("process.started")) + ": " + _toDisplayString(_unref(formatDateTime)(__props.startedAt)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["transition-all duration-500 overflow-hidden", { 'max-h-screen': extended.value, 'max-h-0': !extended.value }])
    }, [
      _createVNode(ProcessTable, {
        class: "mt-3 border-t-2 border-dashed border-gray-300",
        processes: __props.processes
      }, null, 8, ["processes"])
    ], 2)
  ]))
}
}

})